require("es6-promise/auto");

var fallback = require("../vendors/fallback/fallback.min");
var libraries = {
    "jQuery": {
        urls: [
            "//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js",
            __BaseAssetPath__ + "vendors/jquery/jquery.min.js?v=3.2.1"
        ],
        integrity: "sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=",
        crossorigin: "anonymous"
    }
};

fallback.ready(["jQuery"], function () {
    import(/* webpackChunkName: "main" */ "./main");
});

fallback.load(libraries);